/* eslint-disable no-unused-vars */
import React, { forwardRef } from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const defaultMaskOptions = {
  prefix: '$',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: true,
  decimalSymbol: '.',
  decimalLimit: 2,
  allowNegative: false,
  allowLeadingZeroes: false,
};

const CurrencyInput = forwardRef(({ maskOptions, ...inputProps }, ref) => {
  const currencyMask = createNumberMask({
    ...defaultMaskOptions,
    ...maskOptions,
  });

  return <MaskedInput mask={currencyMask} {...inputProps} />;
});

CurrencyInput.defaultProps = {
  inputMode: 'numeric',
  maskOptions: {},
};

export default CurrencyInput;
